export default __webpack_public_path__ + "static/multiindustry-62d0483ce2acad8179798b776dea28b8.svg";